import React, { useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const navigate = useNavigate();
  
  const [credentials, setCredentials] = useState({ 
    email: "", 
    password: "" 
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const openLink = (url) => {
    window.open(url, '_blank'); 
 };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    
    if (!credentials.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(credentials.email)) {
      newErrors.email = "Invalid email format";
    }
    
    if (!credentials.password) {
      newErrors.password = "Password is required";
    } else if (credentials.password.length < 5) {
      newErrors.password = "Password must be at least 5 characters";
    }
    
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    
    try {
      const response = await fetch("https://propertysearch.ai/api/auths/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password,
        }),
      });

      const data = await response.json();

      if (data.status) {
        const { user, token } = data;
        
        // Store user data
        localStorage.setItem("firstName", user.firstname);
        localStorage.setItem("lastName", user.lastname);
        localStorage.setItem("userRole", user.userrole);
        localStorage.setItem("userId", user.id);
        localStorage.setItem("token", token);
        localStorage.setItem("address", user.city);
        localStorage.setItem("email", user.email);

        if (user.userrole === "agent") {
          localStorage.setItem("latitude", user.latitude);
          localStorage.setItem("longitude", user.longitude);
        }

        toast.success("Welcome On Properysearch!");
        navigate("/userDashboard");
      } else {
        toast.error(data.message || "Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    
         <nav class="navbar navbar-expand-lg fixed-top pt-0 pt-lg-2 ">
                     <Link to="/" class="navbar-brand ">
                       <img
                         src="../images/logo-property-nexus-removebg-preview.png"
                         alt="Property Nexus"
                         height={170}
                         width={200}
                       />
                     </Link>
                 </nav>    
      
    <div className="login-container d-flex align-items-center justify-content-center" style={{marginTop:"7%"}}>
      <div className="card login-card shadow-sm border-0 " >
        <div className="card-body ">
          {/* Logo */}
          <div className="text-center mb-4">
            <img 
              src="/images/logo-property-nexus-removebg-preview.png" 
              alt="Property Search" 
              style={{ height: "100px" }} 
            />
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className={`form-control form-control-md ${errors.email ? "is-invalid" : ""}`}
                id="email"
                placeholder="Enter your email"
                value={credentials.email}
                onChange={(e) => setCredentials({...credentials, email: e.target.value})}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>

            {/* Password Field */}
            <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control ${errors.password ? "is-invalid" : ""}`}
                      id="password"
                      placeholder="Enter your password"
                      value={credentials.password}
                      onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      {showPassword ? <BsEyeSlash /> : <BsEye />}
                    </button>
                  </div>
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>

                {/* Forgot Password Link */}
                <div className="text-end mb-4">
                  <Link 
                    to="/ForgetPassword"
                    className="text-decoration-none text-primary small"
                  >
                    Forgot password?
                  </Link>
                </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="btn btn-primary w-100 py-2 "
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Signing In...
                </>
              ) : "Sign In"}
            </button>
          </form>

          {/* Sign Up Link */}
          <div className="text-center mt-4 pt-3 border-top">
            <p className="text-muted mb-0">
              Don't have an account?{" "}
              <Link to="/Registration" className="text-primary fw-semibold text-decoration-none">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>

     {/* Footer */}
    
      {/* Minimal CSS for elements Bootstrap doesn't handle perfectly */}
      <style jsx>{`
        .login-container {
          padding: 1rem;
        }
        .login-card {
          width: 100%;
          max-width: 450px;
          border-radius: 0.75rem;
        }
      `}</style>
    </div>


    <footer className="bg-white py-3 border-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="social-media">
                <span className="me-2">Follow us:</span>
                <a style={{ cursor: 'pointer' }}  onClick={() => openLink('https://www.facebook.com/profile.php?id=61561067648457')} >
            <img src="images/face1.png" alt="Facebook" style={{height:"25px", width:"25px"}} />
          </a>
         
          <a style={{ cursor: 'pointer' }} onClick={() => openLink('https://linkedin.com/company/property-search-cepp')} >
           <img src="images/link1.png" alt="LinkedIn" style={{height:"25px", width:"25px"}} />
          </a>
          
           <a style={{ cursor: 'pointer' }} onClick={() => openLink('https://www.instagram.com/propertysearch.ai?igsh=MTZsbzhqbDJyeHhlbA==')} > 
            <img src="images/insta1.png" alt="Instagram" style={{height:"25px", width:"25px"}} />
           </a>
              </div>
            </div>
            <div className="col-md-6 text-md-end">
              <p className="mb-0 small text-muted">©{new Date().getFullYear()} Propertysearch - All Rights Reserved</p>
            </div>
          </div>
        </div>
      </footer>
      
    </>
  );
}

export default Login;